import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

const COOKIE_CONSENT_KEY = "bunadstuggu_cookie_consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6">
      <div className="max-w-2xl mx-auto bg-charcoal text-white rounded-lg shadow-elevated p-5 md:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="w-6 h-6 shrink-0 text-white/70 hidden sm:block" />
        <div className="flex-1">
          <p className="font-sans text-sm leading-relaxed text-white/80">
            Denne nettsiden bruker nødvendige informasjonskapsler (cookies) for innlogging og sikkerhet. 
            Vi bruker ingen markedsføringscookies.{" "}
            <Link to="/personvern" className="underline text-white hover:text-white/70 transition-colors">
              Les mer i vår personvernerklæring
            </Link>.
          </p>
        </div>
        <Button
          onClick={handleAccept}
          size="sm"
          className="bg-white text-charcoal hover:bg-white/90 font-sans shrink-0"
        >
          Godta
        </Button>
      </div>
    </div>
  );
};

export default CookieBanner;
